<template>
  <v-app>
    <app-loading v-if="loading"></app-loading>
    <v-dialog v-model="authDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition">
        <v-app>
              <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                  <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
                  <phone-ui @userVerified="waitToLoadUserData"></phone-ui>
                </v-flex>
              </v-layout>
        </v-app>
    </v-dialog>
    <v-dialog v-model="nameDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition">
      <v-card>
        <v-app>
              <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                  <app-loading v-if="loading"></app-loading>
                  <v-card v-else>
<!--                    <v-btn @click="onlogout">logout</v-btn>-->
                    <v-card-title>Contact Name</v-card-title>
                    <v-card-text>
                      <form @submit.prevent="createClientProfile">
                        <v-layout row>
                          <v-text-field
                              class="pa-3"
                              outlined
                              v-model="name"
                              placeholder="Sam"
                              clearable
                          ></v-text-field>
                        </v-layout>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn v-if="name !== ''" @click="createClientProfile" outlined text class="blue" type="submit" dark>
                            Save
                          </v-btn>
                        </v-card-actions>
                      </form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
        </v-app>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import {getAuth} from "firebase/auth";
import {doc, setDoc, addDoc, collection} from "firebase/firestore";
export default {
  props: ['publicListingId', 'orderId', 'routeTo', 'routeType'],
  data () {
    return {
      authDialog: false,
      user: null,
      nameDialog: false,
      name: '',
      quoteId: null
    }
  },
  created () {
    this.quoteId = this.orderId
    // this.$store.dispatch('setLoading', true)
    const auth = getAuth()
    // console.log(auth.currentUser)
    // let db = this.$store.state.db
    //check current user
    let user = auth.currentUser
    if (user) {
      if (user.isAnonymous) {
        //if phoneAuth false open phoneAuth
        this.authDialog = true
        //check user profile
      } else {

        let authUser = this.authUser
        console.log(authUser)
        if(authUser.name) {

          // if (this.routeType === 'makePayment') {
          //   this.$router.push('/stripeCheckout/' + this.authUser.uid +'/'
          //       + this.publicListingId + '/'
          //       + this.orderId
          //   )
          // }
          // if (authUser.activeQuoteId) {
          //   this.quoteId = authUser.activeQuoteId
          //   this.setQuoteData (authUser.activeQuoteId)
          // } else {
          //   this.quoteId = this.orderId
          //   this.setQuoteData (this.orderId)
          // }
        } else {
          // this.quoteId = this.orderId
          // if (this.transactionObj) {
          //   this.name = this.transactionObj.invoiceObj.contactName
          // }
          this.nameDialog = true
        }
        // console.log(user)
        // if user profile exist then check routeType
      }
    } else this.authDialog = true

  },
  // created () {
  //   //if user profile exist then check routeType
  //     //if routeType is makePayment route to stripe payment page
  //     //else leave blank
  //   //if user profile doesn't exist
  //     //open name dialog
  //     //on close name dialog check routeType
  //       //save userProfile
  //       //if routeType is makePayment route to stripe payment page
  // },
  computed: {
    transactionObj () {
      let obj = this.$store.getters.transactionObj
      return obj
    },
    loading () {
      return this.$store.getters.loading
    },
    error () {
      return this.$store.getters.error
    },
    authUser () {
      let user = this.$store.getters.user
      // console.log(user)
      return user
    },

  },
  methods: {
    openAuthDialog () {
      this.nameDialog = false
      this.authDialog = true
    },
    onlogout () {
      this.$store.dispatch('logout')
    },
    waitToLoadUserData () {
      console.log('loading user')
      this.$store.dispatch('setLoading', true)
      setTimeout(this.checkUserProfile, 2000);
    },
    checkUserProfile () {
      console.log('In checkPhoneAuth Loading user profile')
      this.$store.dispatch('setLoading', true)
      if(this.authUser.name) {
        if (this.routeType === 'makePayment') {
          this.$store.dispatch('setLoading', false)
          // /stripeCheckout/:uid/:publicListingId/:invoiceId
          this.$router.push('/stripeCheckout/' + this.authUser.uid +'/'
              + this.publicListingId + '/'
              + this.orderId
          )
        }
        if(this.routeType === 'createQuote') {
          if(this.authUser.activeQuoteId) {
            this.setQuoteData(this.authUser.activeQuoteId)
          } else {
              this.setQuoteData(this.orderId)
          }
        }
      }
      else {
         if (this.transactionObj) {
           this.name = this.transactionObj.invoiceObj.contactName
        }
        this.$store.dispatch('setLoading', false)
        this.nameDialog = true
      }
    },
    createClientProfile () {
      console.log('In create profile')
      const auth = getAuth()
      let clientInfo = auth.currentUser
      // let db = this.$store.state.db
      let providerRef
      // update to service provider collection and update link to include fulfillment id
      //
      //
      //
      //
      //
      //
      // let clientRef = doc(db, 'customers', clientInfo.uid)
      //let quoteRef = doc(db, 'customers', clientInfo.uid, 'bookings',  this.quoteId)
      let clientObj = {
        name: this.name,
        uid: clientInfo.uid,
        phoneNumber: clientInfo.phoneNumber,
        created: Date.now(),
        connectedPublicListingId: this.publicListingId,
      }
      if (this.transactionObj) {
        clientObj.activeBookingId = this.transactionObj.invoiceId
        if (this.transactionObj.invoiceObj.contactEmail) {
          clientObj.email = this.transactionObj.invoiceObj.contactEmail
        }
      }
      if (this.routeType === 'createQuote') {
        let lineItemsDetails = this.$store.getters.anonQuoteDetails
        let listingId = lineItemsDetails.activeListingId
        console.log(listingId)
        console.log(lineItemsDetails)
        clientObj.activeQuoteId = this.quoteId
        clientObj.activeListingId = listingId
        if(lineItemsDetails.lineItems) {
          clientObj.lineItems = lineItemsDetails.lineItems
        }
        if(lineItemsDetails.addOnItems) {
          clientObj.addOnItems = lineItemsDetails.addOnItems
        }
        if(lineItemsDetails.additionalLocations) {
          clientObj.additionalLocations = lineItemsDetails.additionalLocations
        }
        if(lineItemsDetails.deliveryLocation) {
          clientObj.deliveryLocation = lineItemsDetails.deliveryLocation
        }
        if(!this.quoteId) {
          clientObj.activeQuoteId = this.orderId
        }
      }
      this.$store.dispatch('setUserData', clientObj)
      // console.log(clientObj)
      return setDoc(providerRef, clientObj)
          .then(() => {
            if (this.routeType === 'makePayment') {
              this.$router.push('/stripeCheckout/' + clientObj.uid +'/'
                  + this.publicListingId + '/'
                  + this.orderId
              )
            }
            if (this.routeType === 'createQuote') {
              this.setQuoteData(this.quoteId)
            }
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setError', err)
          })
    },
    setQuoteData (quoteId) {
      let lineItemsDetails = this.$store.getters.anonQuoteDetails
      let listingId = lineItemsDetails.activeListingId
      if(!lineItemsDetails) {
        lineItemsDetails = this.authUser
      }
      let db = this.$store.state.db
      let quoteRef = doc(db, 'customers', this.authUser.uid, 'quotes',  quoteId)
      let quoteUpdateRef = collection(db, 'customers', this.authUser.uid, 'quotes',  quoteId, 'updates')
      // console.log(lineItemsDetails)
      if (lineItemsDetails) {
        let quoteObj = {
          clientInfo: {
            name: this.authUser.name,
            uid: this.authUser.uid,
            phoneNumber: this.authUser.phoneNumber,
            created: Date.now(),
            connectedPublicListingId: this.publicListingId,
            activeListingId: listingId
          },
          created: Date.now(),
        }
        quoteObj.listingId = listingId
        // quoteObj.lineItems = lineItemsDetails.lineItems
        if(lineItemsDetails.lineItems) {
          quoteObj.lineItems = lineItemsDetails.lineItems
        }

        if(lineItemsDetails.addOnItems) {
          quoteObj.addOnItems = lineItemsDetails.addOnItems
        }
        if(lineItemsDetails.additionalLocations) {
          quoteObj.additionalLocations = lineItemsDetails.additionalLocations
        }
        if(lineItemsDetails.deliveryLocation) {
          quoteObj.deliveryLocation = lineItemsDetails.deliveryLocation
        }
        quoteObj.status = 'createQuote'
        // console.log(quoteObj)
        setDoc(quoteRef,quoteObj)
            .then (() => {
              return addDoc(quoteUpdateRef, quoteObj)
            })
            .then (()=> {
              this.$store.dispatch('setLoading', false)
              this.$router.push('/quotes/'
                  + this.publicListingId + '/'
                  + listingId +'/'
                  + quoteId)
            })
            .catch(err => {
              console.log(err)
              this.$store.dispatch('setLoading', false)
              this.$store.dispatch('setError', err)
            })
      }

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>

<!--http://localhost:8080/smsAuth/c986cc2f-419c-4e75-b5c1-4b5264acc198/Zaaxxo4LGdZdCA7HeV3r/mlItem/autoImgRecognition/13712420-e954-11ed-9a50-df946bfd1bb0-->
